import styled from "styled-components";

export const CurrencyAmountInputBox = styled.div`
    border: 2px solid ${({theme}) => theme.colors.boxBorderContrast};
    display: inline-flex;
    border-radius: 5px;
    overflow: hidden;
    padding: 5px 0;
`;